module.exports = __webpack_public_path__ + "static/img/pan.cfcd3dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/pan.png
// module id = d6gp
// module chunks = 2